import React from "react";
import ReactSlider from "react-slider";
import icons from "../../icons.config";

const FilterPanel = ({
  isFilterOpen,
  toggleFilter,
  appliedFilterCount,
  priceFilter,
  setPriceFilter,
  isPriceOpen,
  togglePrice,
  isSizeOpen,
  toggleSize,
  appliedFilters,
  handleSizeChange,
  clearAllFilters,
  handleRemoveFilter,
  toggleSort,
  isSortOpen,
  handleSortOptionClick,
  filterOptions,
  isColorOpen,
  toggleColor,
  handleColorChange,
  sortOptions,
  selectedSort,
  applyFilters,
}) => {
  console.log("FilterPanel props - filterOptions:", filterOptions);
  console.log("isSizeOpen:", isSizeOpen);
  console.log("Selected filters:", appliedFilters);
  console.log("Price filter:", priceFilter);
  console.log("Selected sort:", selectedSort);

  const hasFilters =
    appliedFilters.sizes.length > 0 ||
    appliedFilters.colors.length > 0 ||
    appliedFilters.min_price ||
    appliedFilters.max_price;

  return (
    <div
      className={`fixed top-0 left-0 h-full w-[80%] md:w-[60%] lg:w-1/3 bg-tertiary p-5 z-20 transform transition-transform duration-300 ease-in-out 
        ${isFilterOpen ? "translate-x-0" : "-translate-x-full"}
        lg:absolute lg:h-full top-14 md:top-20 lg:left-0 pl-12 lg:pl-32`}
    >
      {/* Header Section */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-outfit font-light text-2xl">Filters</h2>
        <button
          onClick={toggleFilter}
          className="text-hcolor hover:text-primary1 focus:outline-none"
        >
          <img src={icons.close} alt="close" className="w-6 h-6" />
        </button>
      </div>

      {/* Selected Filters and Clear All */}
      {hasFilters && (
        <div className="mb-4">
          <div className="flex flex-wrap gap-2">
            {appliedFilters.sizes.map((size) => (
              <span
                key={size}
                className="bg-hcolor text-tertiary px-2 py-1 rounded flex items-center text-sm"
              >
                {size}
                <button
                  onClick={() => handleRemoveFilter("size", size)}
                  className="ml-2 text-tertiary hover:text-primary1"
                >
                  ×
                </button>
              </span>
            ))}
            {appliedFilters.colors.map((color) => (
              <span
                key={color}
                className="bg-hcolor text-tertiary px-2 py-1 rounded flex items-center text-sm"
              >
                {color}
                <button
                  onClick={() => handleRemoveFilter("color", color)}
                  className="ml-2 text-tertiary hover:text-primary1"
                >
                  ×
                </button>
              </span>
            ))}
            {(appliedFilters.min_price || appliedFilters.max_price) && (
              <span className="bg-hcolor text-tertiary px-2 py-1 rounded flex items-center text-sm">
                Rs. {appliedFilters.min_price || "Min"} - Rs. {appliedFilters.max_price || "Max"}
                <button
                  onClick={() => handleRemoveFilter("price")}
                  className="ml-2 text-tertiary hover:text-primary1"
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      )}
      <div className="mb-4">
        <button
          onClick={clearAllFilters}
          className="text-hcolor hover:text-primary1 underline font-outfit font-light text-sm"
        >
          Clear All
        </button>
      </div>

      {/* Price Filter Section */}
      <div>
        <div className="flex justify-between items-center cursor-pointer" onClick={togglePrice}>
          <h3 className="font-normal font-outfit">Price</h3>
          <img
            src={icons.dropdown}
            alt="dropdown"
            className={`transform transition-transform ${isPriceOpen ? "-rotate-90" : ""}`}
          />
        </div>
        {isPriceOpen && (
          <div className="mt-3 space-y-3">
            <div className="flex justify-stretch gap-4">
              <div>
                <span className="text-lg">Rs. </span>
                <input
                  type="number"
                  name="min"
                  value={priceFilter.min}
                  onChange={(e) => {
                    const value = e.target.value === "" ? "" : String(parseInt(e.target.value) || 0);
                    console.log("Min input changed to:", value);
                    setPriceFilter((prev) => ({ ...prev, min: value }));
                  }}
                  className="border-2 border-primary1 px-3 py-2 text-hcolor font-medium w-1/2 appearance-none"
                />
              </div>
              <div>
                <span className="text-lg">Rs. </span>
                <input
                  type="number"
                  name="max"
                  value={priceFilter.max}
                  onChange={(e) => {
                    const value = e.target.value === "" ? "" : String(parseInt(e.target.value) || 0);
                    console.log("Max input changed to:", value);
                    setPriceFilter((prev) => ({ ...prev, max: value }));
                  }}
                  className="border-2 border-primary1 px-3 py-2 text-hcolor font-medium w-1/2 appearance-none"
                />
              </div>
            </div>
            <div className="flex items-center">
              <ReactSlider
                className="w-full"
                value={[
                  priceFilter.min === "" ? filterOptions?.min_price || 0 : Number(priceFilter.min),
                  priceFilter.max === "" ? filterOptions?.max_price || 0 : Number(priceFilter.max),
                ]}
                onChange={(values) => {
                  const newPriceFilter = { min: String(values[0]), max: String(values[1]) };
                  console.log("Slider changed to:", newPriceFilter);
                  setPriceFilter(newPriceFilter);
                }}
                min={filterOptions?.min_price || 0}
                max={filterOptions?.max_price || 0}
                step={1}
                renderTrack={(props, state) => {
                  const { key, ...restProps } = props;
                  return (
                    <div
                      key={key}
                      {...restProps}
                      style={{
                        ...restProps.style,
                        height: "4px",
                        background:
                          state.index === 0 ? "#ddd" : state.index === 1 ? "#650D1B" : "#ddd",
                      }}
                    />
                  );
                }}
                renderThumb={(props) => {
                  const { key, ...restProps } = props;
                  return (
                    <div
                      key={key}
                      {...restProps}
                      style={{
                        ...restProps.style,
                        height: "15px",
                        width: "15px",
                        borderRadius: "50%",
                        background: "#650D1B",
                        transform: "translate(-5px, -5px)",
                      }}
                    />
                  );
                }}
              />
            </div>
          </div>
        )}
      </div>

      {/* Size Filter Section */}
      <div className="mt-6">
        <div className="flex justify-between items-center cursor-pointer" onClick={toggleSize}>
          <h3 className="font-normal font-outfit">Size</h3>
          <img
            src={icons.dropdown}
            alt="dropdown"
            className={`transform transition-transform ${isSizeOpen ? "-rotate-90" : ""}`}
          />
        </div>
        {isSizeOpen && (
          <div className="mt-3 space-y-2">
            {!filterOptions?.sizes || filterOptions.sizes.length === 0 ? (
              <p>No sizes available</p>
            ) : (
              filterOptions.sizes.map((size, index) => (
                <div key={`${size}-${index}`} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id={`${size}-${index}`}
                    className="cursor-pointer accent-primary1"
                    checked={appliedFilters?.sizes?.includes(size) || false}
                    onChange={() => handleSizeChange(size)}
                  />
                  <label htmlFor={`${size}-${index}`} className="cursor-pointer text-gray-700">
                    {size}
                  </label>
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {/* Colors Filter Section */}
      <div className="mt-6">
        <div className="flex justify-between items-center cursor-pointer" onClick={toggleColor}>
          <h3 className="font-normal font-outfit">Colors</h3>
          <img
            src={icons.dropdown}
            alt="dropdown"
            className={`transform transition-transform ${isColorOpen ? "-rotate-90" : ""}`}
          />
        </div>
        {isColorOpen && (
          <div className="mt-3 space-y-2">
            {!filterOptions?.colors || filterOptions.colors.length === 0 ? (
              <p>No colors available</p>
            ) : (
              filterOptions.colors.map((color, index) => (
                <div key={`${color}-${index}`} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id={`${color}-${index}`}
                    className="cursor-pointer accent-primary1"
                    checked={appliedFilters?.colors?.includes(color) || false}
                    onChange={() => handleColorChange(color)}
                  />
                  <label htmlFor={`${color}-${index}`} className="cursor-pointer text-gray-700">
                    {color}
                  </label>
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {/* Sort Section */}
      <div className="lg:hidden mt-6">
        <div className="flex justify-between items-center cursor-pointer" onClick={toggleSort}>
          <h3 className="font-normal font-outfit">Sort By</h3>
          <img
            src={icons.dropdown}
            alt="dropdown"
            className={`transform transition-transform ${isSortOpen ? "-rotate-180" : ""}`}
          />
        </div>
        {isSortOpen && (
          <div className="mt-3 space-y-2">
            {sortOptions.map((option) => (
              <div key={option} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id={option}
                  className="cursor-pointer accent-primary1"
                  checked={selectedSort === option}
                  onChange={() => handleSortOptionClick(option)}
                />
                <label
                  htmlFor={option}
                  className="cursor-pointer text-primary1 font-outfit font-light text-lg"
                >
                  {option}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Apply Filters Button */}
      <div className="mt-6">
        <button
          onClick={applyFilters}
          className="border-2 text-hcolor hover:text-tertiary hover:bg-hcolor text-center py-2 w-[96%] font-outfit font-light"
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;